export default __webpack_public_path__ + "static/media/31-WalkInTheMeadow.6be4af9b.jpeg";